import {
  PaymentProviderType,
  RefundStatusType,
  type RefundsFilterInputType,
} from "@/types/graphql/partner.generated";
import {
  isEnumValue,
  toIdList,
  toIsoDate,
} from "@/partner/shared/utils/filterValues";

/**
 * Маппинг значений фильтра из querystring (`FilterProvider` -> `qs.parse`) в
 * аргумент запроса возвратов. Проверки значений живут в общем модуле
 * `shared/utils/filterValues` (enum'ы, даты, списки id), здесь остаётся
 * только раскладка по полям запроса. Пустой результат отдаётся как
 * `undefined`, а не `{}`, чтобы запрос без фильтра вёл себя как раньше.
 */
export function buildRefundsFilter(
  filter: Record<string, unknown>
): RefundsFilterInputType | undefined {
  const result: RefundsFilterInputType = {};

  if (typeof filter.search === "string" && filter.search) {
    result.search = filter.search;
  }

  // Статус общий для вкладок Refunds/Disputes лежит в одном ключе
  // `filter[status]`, но значения у вкладок из разных enum'ов: чужое
  // значение здесь просто не пройдёт проверку и будет проигнорировано.
  if (isEnumValue(RefundStatusType, filter.status)) {
    result.status = filter.status;
  }

  const productIds = toIdList(filter.productIds);
  if (productIds) result.productIds = productIds;

  if (Array.isArray(filter.providers)) {
    const providers = filter.providers.filter(
      (provider): provider is PaymentProviderType =>
        isEnumValue(PaymentProviderType, provider)
    );
    if (providers.length > 0) result.providers = providers;
  }

  const dateFrom = toIsoDate(filter.dateFrom);
  if (dateFrom) result.dateFrom = dateFrom;

  const dateTo = toIsoDate(filter.dateTo);
  if (dateTo) result.dateTo = dateTo;

  return Object.keys(result).length > 0 ? result : undefined;
}
